import { Nullable } from "@/general/custom-types/CustomTypes";
import { FacilityDashboardModel } from "@/context/facility/model/FacilityDashboardModel";
import { DataLoggerDashboardModel } from "@/context/data_logger/model/DataLoggerDashboardModel";
import { MeterDashboardModel } from "@/context/meter/model/MeterDashboardModel";

export class DashboardContext {
  customer: Nullable<number>;
  facility: Nullable<number>;
  model: Nullable<FacilityDashboardModel>;
  dataLoggerSelection: Array<DataLoggerDashboardModel> = [];
  expanded: Array<MeterDashboardModel> = [];

  constructor(
    customer?: Nullable<number>,
    facility?: Nullable<number>,
    model?: Nullable<FacilityDashboardModel>,
    dataLoggerSelection: Array<DataLoggerDashboardModel> = [],
    expanded: Array<MeterDashboardModel> = []
  ) {
    this.customer = customer;
    this.facility = facility;
    this.model = model;
    this.dataLoggerSelection = dataLoggerSelection;
    this.expanded = expanded;
  }
}
